var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var ColumnsIcon = function (props) { return (_jsx("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "M5.83335 17.5V2.5H2.50002C2.27901 2.5 2.06704 2.5878 1.91076 2.74408C1.75448 2.90036 1.66669 3.11232 1.66669 3.33333V16.5C1.66669 17.0523 2.1144 17.5 2.66669 17.5H5.83335ZM12.5 17.5V2.5H7.50002V17.5H12.5ZM17.3334 17.5C17.8856 17.5 18.3334 17.0523 18.3334 16.5V3.33333C18.3334 3.11232 18.2456 2.90036 18.0893 2.74408C17.933 2.5878 17.721 2.5 17.5 2.5C17.279 2.5 14.1667 2.5 14.1667 2.5V17.5H17.3334Z", fill: "currentColor" }) }))); };
